import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationMenuComponent } from '../navigation-menu/navigation-menu.component';
import { LayoutService } from '@rx-applications/shared/utils';

@Component({
  standalone: true,
  selector: 'rx-applications-feature-shell-container',
  templateUrl: './shell-container.component.html',
  styleUrl: './shell-container.component.scss',
  imports: [RouterOutlet, CommonModule, NavigationMenuComponent],
})
export class FeatureShellContainerComponent {
  layoutService = inject(LayoutService);
}
